(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-skeleton.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-skeleton.js');
'use strict';

const TopHeader = svs.myProfile.react.shared.components.TopHeader;
const Skeleton = svs.myProfile.react.shared.components.Skeleton;
const _svs$myProfile$consta = svs.myProfile.constants,
  titles = _svs$myProfile$consta.titles,
  icons = _svs$myProfile$consta.icons;

const PersonalizationSettingsSkeleton = () => React.createElement(React.Fragment, null, React.createElement("div", {
  className: "margin-top-3"
}, React.createElement(TopHeader, {
  icon: icons.ADAPT,
  title: titles.ADAPT
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 4,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 3,
  boxHeight: 2,
  boxWidthProcent: 100,
  topMargin: 1
})), React.createElement("div", {
  className: "margin-top-2"
}, React.createElement(TopHeader, {
  icon: icons.OFFERS,
  title: titles.OFFERS
}), React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 6,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 2,
  boxWidthProcent: 100,
  topMargin: 1
})));
svs.myProfile.react.pages.communicationSettings.personalizationSettings.PersonalizationSettingsSkeleton = PersonalizationSettingsSkeleton;

 })(window);